// extracted by mini-css-extract-plugin
export default {"box":"index_box_AycxB","oneLine":"index_oneLine_1VpTa","twoLine":"index_twoLine_Qe0c-"};